import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-creator-space',
  standalone: true,
  imports: [RouterLink],
  template: `
    <section class="section creator-space-page">
      <div class="page-title-block creator-space-heading">
        <h1>CREATOR SPACE</h1>
        <span class="title-line"></span>
      </div>

      @if (auth.canUseCreatorSpace()) {
        <div class="creator-welcome card accent-card">
          <div>
            <small>Angemeldet als</small>
            <h2>{{ auth.activeUser().username }}</h2>
          </div>
          <span>{{ displayRole(auth.activeUser().role) }}</span>
        </div>

        <div class="creator-space-grid">
          <article class="creator-space-card card accent-card">
            <small>Content</small>
            <h2>Contentplan</h2>
            <p>Videos, Streams und Shorts vorbereiten.</p>
            <a routerLink="/" class="button secondary">Öffnen</a>
          </article>

          <article class="creator-space-card card accent-card">
            <small>Live Vorbereitung</small>
            <h2>Show Lobby</h2>
            <p>Shows vorbereiten, zwischenspeichern und aktive Lobbys per Code öffnen.</p>
            <a routerLink="/show-lobby" class="button secondary">Öffnen</a>
          </article>

          <article class="creator-space-card card accent-card">
            <small>Shows</small>
            <h2>Show-Verwaltung</h2>
            <p>Formate, Termine und Rückblicke verwalten.</p>
            <a routerLink="/spielshows" class="button secondary">Öffnen</a>
          </article>

          <article class="creator-space-card card accent-card" [class.disabled-card]="!auth.isAdmin()">
            <small>Admin</small>
            <h2>Fragenkatalog</h2>
            <p>Private Fragen-Tabellen pro Spielshow verwalten.</p>
            @if (auth.isAdmin()) {
              <a routerLink="/fragenkatalog" class="button secondary">Öffnen</a>
            } @else {
              <button class="button secondary" disabled>Nur Admin</button>
            }
          </article>

          <article class="creator-space-card card accent-card disabled-card">
            <small>Bald</small>
            <h2>Rollen & Team</h2>
            <p>Admin, Content Creator und Moderator Rechte zentral verwalten.</p>
            <button class="button secondary" disabled>Kommt später</button>
          </article>
        </div>
      } @else {
        <article class="creator-welcome card accent-card">
          <div>
            <small>Kein Zugriff</small>
            <h2>Dieser Bereich ist nur für Creator-Rollen sichtbar.</h2>
          </div>
          <a routerLink="/login" class="button primary">Einloggen</a>
        </article>
      }
    </section>
  `
})
export class CreatorSpaceComponent {
  readonly auth = inject(AuthService);

  displayRole(role: string): string {
    const normalized = role.trim().toLowerCase().replace(/[-_\s]/g, '');

    if (normalized === 'admin') {
      return 'Admin';
    }

    if (normalized === 'moderator') {
      return 'Moderator';
    }

    if (normalized === 'contentcreator' || normalized === 'creator') {
      return 'Content Creator';
    }

    return role;
  }
}
